import type { ReactNode } from "react"
import { normalizeForSearch } from "../features/benefit/filterBenefits.js"
import styles from "./HighlightMatch.module.css"

interface Props {
  text: string
  query: string
}

// Wraps every occurrence of `query` in `text` with a highlighted <mark>,
// matching case/width-insensitively (same normalization as the search
// filter itself) while preserving the original text's casing on screen.
export function HighlightMatch({ text, query }: Props) {
  const normalizedQuery = normalizeForSearch(query.trim())
  if (!normalizedQuery) return <>{text}</>

  const normalizedText = normalizeForSearch(text)
  const parts: ReactNode[] = []
  let cursor = 0
  let index = normalizedText.indexOf(normalizedQuery, cursor)
  if (index === -1) return <>{text}</>

  let key = 0
  while (index !== -1) {
    parts.push(text.slice(cursor, index))
    parts.push(
      <mark key={key++} className={styles.highlight}>
        {text.slice(index, index + normalizedQuery.length)}
      </mark>
    )
    cursor = index + normalizedQuery.length
    index = normalizedText.indexOf(normalizedQuery, cursor)
  }
  parts.push(text.slice(cursor))
  return <>{parts}</>
}
